import { Navigate, Route } from "react-router-dom";

import { List, Create, Edit } from "../components";

const manufactureRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"manufacture:index"} />,
    <Route path="list" element={<List />} key={"manufacture:list"} />,
    <Route path="create" element={<Create />} key={"manufacture:create"} />,
    <Route path=":manufacturerId" element={<Edit />} key={"manufacture:edit"} />,
];

export default manufactureRoutes;
